import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { SnapshotHistorySetting, CreateSnapshotHistorySettingDto } from 'types';
import { convertSnapshotHistorySettings } from 'api/dtoConverters';

export const updateSnapshotHistorySettings = ({
  data,
  snapshotId,
}: {
  data: CreateSnapshotHistorySettingDto;
  snapshotId: number;
}): Promise<SnapshotHistorySetting> => {
  return axios.put(
    `/api/snapshots/${snapshotId}/history/settings`,
    convertSnapshotHistorySettings(data)
  );
};

type UseUpdateSnapshotHistorySettingsOptions = {
  snapshotId: number;
  config?: MutationConfig<typeof updateSnapshotHistorySettings>;
};

export const useUpdateSnapshotHistorySettings = ({
  config,
  snapshotId,
}: UseUpdateSnapshotHistorySettingsOptions) => {
  return useMutation({
    onMutate: async (updatedHistorySettings) => {
      await queryClient.cancelQueries([
        'snapshot',
        'historySettings',
        snapshotId,
      ]);

      const previousSnapshotHistorySettingss =
        queryClient.getQueryData<SnapshotHistorySetting>([
          'snapshot',
          'historySettings',
          snapshotId,
        ]);

      queryClient.setQueryData(
        ['snapshot', 'historySettings', snapshotId],
        updatedHistorySettings.data
      );

      return { previousSnapshotHistorySettingss };
    },
    onError: (_, __, context: any) => {
      if (context?.previousSnapshotHistorySettingss) {
        queryClient.setQueryData(
          ['snapshot', 'historySettings', snapshotId],
          context.previousSnapshotHistorySettingss
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries([
        'snapshot',
        'historySettings',
        snapshotId,
      ]);
    },
    ...config,
    mutationFn: updateSnapshotHistorySettings,
  });
};
